import * as goodsProcess from './goods-process'



export default [goodsProcess]


// WEBPACK FOOTER //
// ./src/store/modules/cost-accounting/index.js